import {SearchItem, SearchResultDto} from "../search/search-table.dto.res";
import {VehicleHistoryDto} from "./vehicle-history.dto";

export class SearchVehicleHistoryRes extends SearchResultDto {

  public override readonly items: SearchVehicleHistoryItem[] = [];

  constructor(init?: Partial<SearchVehicleHistoryRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchVehicleHistoryItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchVehicleHistoryItem extends VehicleHistoryDto implements SearchItem {

  public override readonly id!: string;

  constructor(init?: Partial<SearchVehicleHistoryItem>) {
    super(init);
    Object.assign(this, init);
  }
}
